import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { smoothlyMenu } from 'app/app.helpers';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, PortalService } from '../../core/core.module';
import { AchEmailDialogComponent, AchEmailModel } from '../ach-email-dialog/ach-email-dialog.component';
import { ConfirmationPaymentMethod } from 'app/core/model/confirmation-payment-method';
import validationEngine from 'devextreme/ui/validation_engine';
import { confirm, custom } from 'devextreme/ui/dialog';
import { Utility } from 'app/core/utility';
declare var jQuery: any;

@Component({
    selector: 'app-portal-confirmation',
    templateUrl: './portal-confirmation.component.html',
    styleUrls: ['./portal-confirmation.component.scss'],
    standalone: false,
})
export class PortalConfirmationComponent implements OnInit {
    // confirmationInfo: any;
    @Input() confirmationInfo: any;
    @Input() displayMode: boolean;
    paymentMethods: any[];
    deliveryOptions: any[];
    confirmationCode: any;
    orderInfo: any;
    orderLineInfos: any;
    resultInfo: any;
    screenHeight: number;
    screenWidth: number;
    complete = false;
    ready = false;

    processing: boolean = false;
    isApproving: boolean = false;
    showDecline: boolean = false;
    achPortalEnabled: boolean = false;
    dealerDeliveryConfirmationEnabled: boolean = false;
    dealerChannelPartner: boolean = false;

    dealerResponse: any = {};

    selectedPaymentMethodId: any;
    confirmedBy: string;
    requestContact: boolean = false;
    cancelReasons = ['I no longer wish to place an order', 'I wish to make changes to my order'];
    selectedCancelReason: string;
    cancelNotes: string;
    conf: any;
    finePrint: any;
    achEmail: AchEmailModel;
    selectedPaymentMethod: any;
    declineMessage: string = 'Confirmed By';
    redOakMethodId = ConfirmationPaymentMethod.Methods.RedOak;
    achMethodId = ConfirmationPaymentMethod.Methods.ACH;
    selectedDelivery: any;
    selectedDeliveryId: number;
    deliveryAcknowledged: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private appInfo: AppInformationService,
        private portalService: PortalService,
        private modalService: BsModalService,
    ) {
        this.getScreenSize();
    }
    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    async ngOnInit() {
        this.confirmationCode = this.route.snapshot.params.id;
        this.appInfo.pleaseWaitShow();

        if (!!this.confirmationInfo) {
            this.confirmationInfo.Dealer = 'Test Dealer';
        } else {
            try {
                await this.getData();
            } catch (error) {
                console.log(error);
            }
        }

        this.appInfo.pleaseWaitHide();
        if (this.screenWidth > 850 && !this.displayMode) this.toggleNavigation();
        this.ready = true;
    }

    async refresh() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        const results = (await this.portalService.getConfirmation(this.confirmationCode)) as any;
        this.confirmationInfo = results.confirmationInfos;
        this.resultInfo = results.result;
        this.orderInfo = results.orderInfos;
        this.orderLineInfos = results.orderInfos.OrderLines;
        this.paymentMethods = results.paymentMethods;
        this.deliveryOptions = results.deliveryOptions;

        this.achPortalEnabled = this.confirmationInfo.AchPortalEnabled;
        this.dealerDeliveryConfirmationEnabled = this.confirmationInfo.DealerDeliveryConfirmationEnabled;
        this.dealerChannelPartner = this.confirmationInfo.DealerChannelPartner;
        this.complete = this.confirmationInfo.Approved || this.confirmationInfo.Declined || this.confirmationInfo.SalesRepConfirmation;
        this.dealerResponse.achEmail = this.confirmationInfo.AchEmailTo;
    }

    async respond(mode?: 'Approve') {
        this.processing = true;
        const valid = await this.portalService.verifyConfirmationStillActive(this.confirmationCode);
        if (!valid) {
            this.notify('This confirmation has expired. Please refresh the page.');
            this.processing = false;
            return;
        }

        this.isApproving = mode === 'Approve';
        const success = this.valid();
        if (!success) {
            this.notify('Please fill in required fields');
            this.processing = false;
            return;
        }

        if (mode === 'Approve' && (this.requiresFreightChangeRequest || (this.requiresDeliveryAcknowledgment && !this.deliveryAcknowledged))) {
            this.processing = false;
            return;
        }

        this.appInfo.pleaseWaitShow();
        const result = await this.portalService.confirmationResponse(
            this.confirmationCode,
            mode,
            this.dealerResponse.selectedPaymentMethodId,
            this.dealerResponse.confirmedBy,
            this.selectedCancelReason,
            this.cancelNotes,
            this.requestContact,
            this.dealerResponse.achEmail,
            this.dealerResponse.northpointOrRedOakNumber,
            this.dealerResponse.selectedDeliveryId,
        );
        if (result) this.complete = true;
        else {
            this.notify('Error processing confirmation');
            this.processing = false;
        }
        this.appInfo.pleaseWaitHide();
        await this.getData();
        this.processing = false;
    }

    freightChangeReasonText = 'Delivery Method Changed - New Confirmation Required';
    freightChangeRequestAutoOpened = false;
    syncFreightChangeRequest() {
        if (this.requiresFreightChangeRequest) {
            if (this.showDecline) return;
            this.showDecline = true;
            this.selectedCancelReason = this.freightChangeReasonText;
            this.cancelNotes =
                'I wish to use Genesis Delivery rather than having my order picked up. Please provide me a new confirmation link with the applicable delivery fees applied.';
            this.declineMessage = 'Submitted By';
            this.freightChangeRequestAutoOpened = true;
        } else if (this.freightChangeRequestAutoOpened) {
            this.showDecline = false;
            this.selectedCancelReason = null;
            this.cancelNotes = null;
            this.declineMessage = 'Confirmed By';
            this.requestContact = false;
            this.freightChangeRequestAutoOpened = false;
        }
    }

    notify(message: string) {
        this.appInfo.notifyToast(message, 'error', 2500, { my: 'center bottom', at: 'center bottom', offset: '0 -50', of: 'body' });
    }

    toggleDecline() {
        this.showDecline = !this.showDecline;
        this.declineMessage = this.showDecline ? 'Submitted By' : 'Confirmed By';
    }

    async emailAchAuthForm() {
        if (this.confirmationInfo.IsAchEmailSent) return;

        // Check if ACH email has already been sent in case the user sent from another tab
        const sentAchEmail = await this.portalService.verifyAchEmailSent(this.confirmationCode);
        if (sentAchEmail) {
            this.appInfo.pleaseWaitShow();
            await this.getData();
            this.appInfo.pleaseWaitHide();
            this.notify('ACH Authorization Form email has already been sent');
            return;
        }

        const modalRef = this.modalService.show(AchEmailDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dealerId: this.confirmationInfo.DealerId,
                confirmationCode: this.confirmationCode,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();

                //create a new Email Message entity based on the result.model
                this.achEmail = result.value;

                this.confirmationInfo.IsAchEmailQueued = true;
                this.confirmationInfo.AchEmailTo = this.achEmail.to;

                console.log('ACH Email Sent', this.confirmationInfo);
                // await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    onPaymentMethodChanged(e: any) {
        this.selectedPaymentMethodId = e.value;
        this.deliveryAcknowledged = false;

        if (!!this.selectedPaymentMethodId) {
            this.selectedPaymentMethod = this.paymentMethods.find((x) => x.Id === this.selectedPaymentMethodId);
        } else {
            this.selectedPaymentMethod = null;
        }

        if (this.selectedPaymentMethodId === ConfirmationPaymentMethod.Methods.ACH) {
            this.dealerResponse.achEmail = this.confirmationInfo.DealerAPEmail;
        } else if (this.selectedPaymentMethodId === ConfirmationPaymentMethod.Methods.Northpoint || this.selectedPaymentMethodId === ConfirmationPaymentMethod.Methods.RedOak) {
            this.dealerResponse.northpointOrRedOakNumber = this.confirmationInfo.NorthpointNumber;
        } else {
            this.dealerResponse.achEmail = '';
            this.dealerResponse.northpointOrRedOakNumber = '';
        }

        this.syncFreightChangeRequest();
    }

    onDeliveryChanged(e: any) {
        this.selectedDeliveryId = e.value;
        this.deliveryAcknowledged = false;
        if (!!e.value) {
            this.selectedDelivery = this.deliveryOptions.find((x) => x.id === e.value);
        } else {
            this.selectedDelivery = null;
        }

        this.syncFreightChangeRequest();
    }

    get hidePaymentMethod(): boolean {
        return this.showDecline && !this.freightChangeRequestAutoOpened;
    }

    get cancelReasonOptions(): string[] {
        return this.freightChangeRequestAutoOpened ? [this.freightChangeReasonText] : this.cancelReasons;
    }

    get hideFreightForDelivery(): boolean {
        return this.dealerDeliveryConfirmationEnabled && !!this.orderInfo?.DeliveryRequiresFreight && !!this.selectedDelivery && !this.selectedDelivery.requiresFreight;
    }

    get switchingToFreightDelivery(): boolean {
        return (
            this.dealerDeliveryConfirmationEnabled &&
            !!this.orderInfo &&
            !this.orderInfo.DeliveryRequiresFreight &&
            !!this.selectedDelivery &&
            !!this.selectedDelivery.requiresFreight
        );
    }

    get requiresFreightChangeRequest(): boolean {
        return this.switchingToFreightDelivery && this.dealerResponse.selectedPaymentMethodId === this.achMethodId;
    }

    get selectedDeliveryChanged(): boolean {
        return !!this.selectedDelivery && this.selectedDelivery.id !== this.orderInfo?.DeliveryOptionId;
    }

    get deliveryAcknowledgmentMessage(): string {
        return this.selectedDeliveryChanged ? this.selectedDelivery?.dealerAcknowledgementMessage : null;
    }

    get requiresDeliveryAcknowledgment(): boolean {
        return this.selectedDeliveryChanged && !!this.selectedDelivery?.acknowledgementRequired;
    }

    get visibleOrderLineInfos() {
        if (!this.orderLineInfos) return this.orderLineInfos;
        return this.hideFreightForDelivery ? this.orderLineInfos.filter((ol) => !ol.IsFreight) : this.orderLineInfos;
    }

    get displayTotal(): number {
        if (!this.orderInfo) return 0;
        if (!this.hideFreightForDelivery) return this.orderInfo.Total;
        const freightTotal = this.orderLineInfos.filter((ol) => ol.IsFreight).reduce((sum, ol) => sum + ol.Price, 0);
        return this.orderInfo.Total - freightTotal;
    }

    get displayAchTotal(): number {
        if (!this.orderInfo) return 0;
        if (!this.hideFreightForDelivery) return this.orderInfo.AchTotal;
        if (this.orderInfo.IsWinterOrder) return this.displayTotal * 0.1;
        const freightAchTotal = this.orderLineInfos.filter((ol) => ol.IsFreight).reduce((sum, ol) => sum + ol.AchPrice, 0);
        return this.orderInfo.AchTotal - freightAchTotal;
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        }
        return true;
    }

    validatePaymentMethod = (e: any) => {
        const paymentMethodId = e.value;
        return !this.isApproving || !!paymentMethodId;
    };

    validateEmail = (e: any) => {
        const emails = e.value;
        return !emails || Utility.validateEmailAddresses(emails);
    };

    async removeAch() {
        //confirm the ach is not approved
        const isAchAbleToDelete = await this.portalService.checkForAchesToDelete(this.confirmationCode);
        if (!isAchAbleToDelete) {
            this.notify('ACH Authorization Form is already approved or declined. Cannot delete.');
            await this.getData();
            return;
        }

        const result = await confirm(`Are you sure you want to DELETE this emailed ACH Authorization?`, this.appInfo.settings.company);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const deleteAch = await this.portalService.deleteAch(this.confirmationCode);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async resendEmail(verify?: boolean) {
        if (verify) {
            const result = await confirm(
                `Are you sure you want to RESEND this emailed ACH Authorization? This will delete exisitng links and create a new ACH Link. Continue?`,
                this.appInfo.settings.company,
            );
            if (!result) return;
        }

        const success = this.resendEmailValid();
        if (!success) {
            this.notify('Please fill in required fields');
            return;
        }
        this.appInfo.pleaseWaitShow();

        const emailSuccess = await this.portalService.sendAchEmail({
            confirmationCode: this.confirmationCode,
            to: this.dealerResponse.achEmail,
            confirmationPaymentMethodId: this.confirmationInfo.ConfirmationPaymentMethodId,
        });
        if (!emailSuccess) {
            this.notify('Error processing confirmation');
        }
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    resendEmailValid() {
        const groupConfig = validationEngine.getGroupConfig('emailValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('emailValidationGroup');
            return result.isValid;
        }
        return true;
    }
}
